import { Logger } from 'UI-Dash-Commons-UI';

const TAG = 'AccountSettingsValidationUtils';

const NAME_ERROR_MESSAGE = 'Invalid Name';
const WEBSITE_ERROR_MESSAGE = 'Invalid Website';

const NON_ASCII_REGEX = /[^\x20-\x7f]/;
const NAME_REGEX = /^[a-zA-Z0-9_'\-., ]+$/;
const MAX_NAME_LENGTH = 255;

const SANITIZE_URL_REGEX = /^.*:\/\//i;
const URL_REGEX = /^((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www\.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w\-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[.!/\\\w]*))?)/i;
const WWW_PREFIX = 'www';
const HTTP_WWWPREFIX = 'http://www.';

export default class AccountSettingsValidationUtils
{
    public static validateName = ( name: string | null ) =>
    {
        let errorMessage;

        if (
            !name ||
            NON_ASCII_REGEX.test( name ) ||
            !NAME_REGEX.test( name ) ||
            name.length > MAX_NAME_LENGTH
        )
        {
            errorMessage = NAME_ERROR_MESSAGE;
            Logger.error( TAG, errorMessage );
        }

        return errorMessage;
    };

    public static validateWebsite = ( website: string | null ) =>
    {
        let errorMessage;

        // allow empty
        if ( !website )
        {
            return;
        }

        const sanitizedWebsite = website.replace( SANITIZE_URL_REGEX, '' );
        const websiteParts = sanitizedWebsite.split( '.' );

        if (
            websiteParts.length < 2
        )
        {
            errorMessage = WEBSITE_ERROR_MESSAGE;
            Logger.error( TAG, errorMessage );
        }
        else if ( websiteParts.length > 2 && ( websiteParts[ 0 ].toLowerCase() === WWW_PREFIX ) )
        {
            websiteParts.shift();
        }

        const normalizedUrl = websiteParts.join( '.' );

        if ( !URL_REGEX.test( HTTP_WWWPREFIX + normalizedUrl ) )
        {
            errorMessage = WEBSITE_ERROR_MESSAGE;
            Logger.error( TAG, errorMessage );
        }


        return errorMessage;
    };

    public static validateParentId = ( parentId: string ) =>
    {
        let errorMessage;

        if ( !parentId )
        {
            errorMessage = NAME_ERROR_MESSAGE;
            Logger.error( TAG, errorMessage );
        }

        return errorMessage;
    };
}
